/**
 * The SayNoWay mark.
 *
 * It used to be a reconstruction: an inline SVG that rebuilt the wordmark from a yellow burst polygon, two cyan bolt
 * paths, three stacked text layers per word and two star polygons — nine shapes and a filter standing in for a drawing
 * that already exists. The owner named the same fault in the PLAY NOW arrow on 12.9.2026: a shape drawn in code carries
 * none of the material of the art around it, and it survives review because it is small.
 *
 * `art/ui/logo-compact@2x.webp` is the drawn mark, already used by the game HUD and How to play. This renders that.
 */
import { art } from '../art';

export function Logo({ size = 'md', tagline = true }: { size?: 'sm' | 'md' | 'lg'; tagline?: boolean }) {
  const w = size === 'lg' ? 660 : size === 'md' ? 560 : 400; // stage units
  return (
    <div class="logo-wrap" style={{ width: w }} aria-label="SayNoWay">
      <img class="logo-img" src={art("/art/ui/logo-compact@2x.webp")} alt="SayNoWay" draggable={false} />
      {tagline && <div class="tag">Bolder people. Brighter nights.</div>}
    </div>
  );
}
